import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50 shadow-sm border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-xl font-bold text-foreground-950 whitespace-nowrap cursor-pointer"
          >
            <span className="w-8 h-8 flex items-center justify-center bg-accent-500 text-background-50 rounded-lg text-sm font-bold">
              糖
            </span>
            <span style={{ fontFamily: "var(--font-heading)" }}>糖果直播</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === "/"
                  ? "text-primary-500"
                  : "text-foreground-700 hover:text-primary-500"
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? "text-primary-500"
                    : "text-foreground-700 hover:text-primary-500"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === "/about"
                  ? "text-primary-500"
                  : "text-foreground-700 hover:text-primary-500"
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i
              className={`text-xl ${isMobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}
            ></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link
              to="/"
              className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}